class SpecialAdCategories {}

SpecialAdCategories.warningMessage = {
  bulkDuplicate:
    "Important: Your Meta ad-account must be verified to run Finance special category campaigns to target: World Wide, United Kingdom, Australia, India, Taiwan",
  specificCountrySelected:
    "Important: Your Meta ad-account must be verified to run Finance special category campaigns for ",
  noCountriesSelected:
    "Important: Your Meta ad-account must be verified to run Finance special category campaigns for World Wide targeting",
}

SpecialAdCategories.none = {
  value: "NONE",
  name: "None (Default)",
}

SpecialAdCategories.financialProductsServices = {
  value: "FINANCIAL_PRODUCTS_SERVICES",
  name: "Financial products and services",
}

SpecialAdCategories.employment = {
  value: "EMPLOYMENT",
  name: "Employment",
}

SpecialAdCategories.housing = {
  value: "HOUSING",
  name: "Housing",
}

SpecialAdCategories.issuesElectionsPolitics = {
  value: "ISSUES_ELECTIONS_POLITICS",
  name: "Social issues, elections or politics",
}

SpecialAdCategories.valueToCategory = {
  NONE: SpecialAdCategories.none,
  FINANCIAL_PRODUCTS_SERVICES: SpecialAdCategories.financialProductsServices,
  EMPLOYMENT: SpecialAdCategories.employment,
  HOUSING: SpecialAdCategories.housing,
  ISSUES_ELECTIONS_POLITICS: SpecialAdCategories.issuesElectionsPolitics,
}

SpecialAdCategories.options = [
  SpecialAdCategories.none,
  SpecialAdCategories.financialProductsServices,
  SpecialAdCategories.employment,
  SpecialAdCategories.housing,
  SpecialAdCategories.issuesElectionsPolitics,
]

export default SpecialAdCategories
